import React from 'react';
import { EyeIcon, RouteIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = [RouteIcon, WrenchIcon, EyeIcon, ZapIcon];
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand" data-id="element-16" data-mp="3io3xfkni3xbi">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3no027m40vss4">
        <h2 id="beneficios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-18" data-mp="38rirmx3nqi6m">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white" data-id="element-19" data-mp="2zsnm7n8ftc4d">
          Una habilidad técnica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="xzzccv1afqfm">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[i];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-navy bg-white p-2.5 text-left" data-id="element-21" data-mp="12yk6ccpy5dvm" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-ice text-navy" aria-hidden="true" data-id="element-22" data-mp="2l4z79t87s372">
                  <Icon size={16} data-id="element-23" data-mp="2g88jsku2y5bm" />
                </span>
                <div data-id="element-24" data-mp="1sh33k4k89b0s">
                  <h3 className="font-sub text-sm font-semibold leading-tight text-brand" data-id="element-25" data-mp="1sie6611xscqb">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-slate-600 sm:text-sm" data-id="element-26" data-mp="22erb5v2xmd0d">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}